import 'core-js/fn/object/entries';

// Convert object properties to query parameters
export function objectToURL(baseURL, obj) {
  const queryString = Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return `${baseURL}?${queryString}`;
}
